import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import * as i4 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { Subject } from 'rxjs';
import * as i2 from '@angular/router';
import * as i3 from 'custom-dropdown';
import * as i5 from 'app-services-library';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/calendar';
import { PrimengLibraryModule } from 'primeng-library';

class CustomCalenderService {
    constructor() { }
}
CustomCalenderService.ɵfac = function CustomCalenderService_Factory(t) { return new (t || CustomCalenderService)(); };
CustomCalenderService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomCalenderService, factory: CustomCalenderService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomCalenderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CustomCalenderComponent_div_0_em_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 8);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomCalenderComponent_div_0_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "width": a0 }; };
const _c1 = function (a0) { return { "leftAlign": a0 }; };
function CustomCalenderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CustomCalenderComponent_div_0_em_4_Template, 2, 0, "em", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵelementStart(6, "p-calendar", 7);
    i0.ɵɵlistener("onSelect", function CustomCalenderComponent_div_0_Template_p_calendar_onSelect_6_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.dateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CustomCalenderComponent_div_0_span_7_Template, 2, 0, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(13, _c0, ctx_r0.inputParams == null ? null : ctx_r0.inputParams.style == null ? null : ctx_r0.inputParams.style.width));
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction1(15, _c1, (ctx_r0.inputParams == null ? null : ctx_r0.inputParams.align) == "left"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.inputParams == null ? null : ctx_r0.inputParams.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.inputParams == null ? null : ctx_r0.inputParams.mandatory);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", ctx_r0.formControlName)("showIcon", true)("readonlyInput", true)("minDate", (ctx_r0.inputParams == null ? null : ctx_r0.inputParams.disablePastDates) ? ctx_r0.currentDate : null)("showButtonBar", true);
    i0.ɵɵattribute("name", ctx_r0.formControlName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r0.inputParams == null ? null : ctx_r0.inputParams.mandatory) && ctx_r0.group.get(ctx_r0.inputParams.name).touched && ctx_r0.group.get(ctx_r0.inputParams.name).value === "");
} }
function CustomCalenderComponent_div_1_em_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 8);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomCalenderComponent_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
const _c2 = function () { return { "width": "30px" }; };
function CustomCalenderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CustomCalenderComponent_div_1_em_4_Template, 2, 0, "em", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p-calendar", 9);
    i0.ɵɵlistener("ngModelChange", function CustomCalenderComponent_div_1_Template_p_calendar_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.formattedDate = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CustomCalenderComponent_div_1_span_6_Template, 2, 0, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.inputParams == null ? null : ctx_r1.inputParams.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.inputParams == null ? null : ctx_r1.inputParams.mandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.inputParams == null ? null : ctx_r1.inputParams.isReadOnly)("minDate", ctx_r1.currentDate)("inputStyle", i0.ɵɵpureFunction0(9, _c2))("ngModel", ctx_r1.formattedDate)("showIcon", true)("showButtonBar", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r1.inputParams == null ? null : ctx_r1.inputParams.mandatory) && ctx_r1.group.get(ctx_r1.inputParams.name).touched && ctx_r1.group.get(ctx_r1.inputParams.name).value === "");
} }
class CustomCalenderComponent {
    constructor(fb, route, customDropdownService, store, appServicesLibraryService) {
        this.fb = fb;
        this.route = route;
        this.customDropdownService = customDropdownService;
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
    }
    ngOnInit() {
        var _a, _b;
        this.userType = sessionStorage.getItem('userTypeRole');
        let inputVal = (this.inputParams.value) ? this.inputParams.value : '';
        const calenderValidators = this.inputParams.mandatory ? [Validators.required] : [];
        this.group.addControl(this.inputParams.name, this.fb.control(inputVal, calenderValidators));
        this.currentDate = new Date();
        /* Retreive selected values while navigating between step - multi step form */
        this.route.queryParams.subscribe(params => {
            const stepParameter = params['step'];
            if (!stepParameter) {
                this.customDropdownService.clearFormValue(this.inputParams.name);
            }
            else {
                this.savedValue = this.customDropdownService.getFormValue(this.formControlName);
                if (this.savedValue) {
                    this.group.controls[this.inputParams.name].patchValue(this.savedValue);
                }
            }
        });
        if ((_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.showTodayByDefault) {
            this.formattedDate = moment(this.currentDate).format('MM/DD/YYYY');
        }
        else {
            if (!inputVal) {
                this.formattedDate = null;
            }
        }
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.toggleInputFields();
            });
        }
        if ((_b = this.inputParams) === null || _b === void 0 ? void 0 : _b.showTodayByDefault) {
            this.inputParams.value = this.formattedDate;
            this.group.controls[this.inputParams.name].patchValue(this.formattedDate);
        }
        else {
            if (!inputVal && !this.savedValue) {
                this.group.controls[this.inputParams.name].patchValue(this.formattedDate);
            }
        }
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    toggleInputFields() {
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
            this.group.disable();
        }
        else {
            this.group.enable();
        }
    }
    dateChange(e) {
        let setDate = moment(e).format("MM/DD/YYYY");
        this.inputParams.value = setDate;
        this.group.controls[this.inputParams.name].patchValue(setDate);
        this.customDropdownService.setFormValue(this.formControlName, setDate);
    }
}
CustomCalenderComponent.ɵfac = function CustomCalenderComponent_Factory(t) { return new (t || CustomCalenderComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3.CustomDropdownService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.AppServicesLibraryService)); };
CustomCalenderComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomCalenderComponent, selectors: [["custom-calender"]], inputs: { formControlName: "formControlName", value: "value", inputParams: "inputParams", inputData: "inputData", group: "group" }, decls: 2, vars: 2, consts: [[3, "formGroup", "style", "ngClass", 4, "ngIf"], ["class", "inlineblock", 4, "ngIf"], [3, "formGroup", "ngClass"], [1, "label-cls", "vd-heading-container", "pb-0"], [1, "common-bene-class-for-translation"], ["class", "error", 4, "ngIf"], [1, "inlineblock"], ["id", "startDate", "yearRange", "1900:2100", "appendTo", "body", "styleClass", "p-form-datepicker", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YYYY", 1, "im-input-calendar", "mw-100", 3, "formControlName", "showIcon", "readonlyInput", "minDate", "showButtonBar", "onSelect"], [1, "error"], ["id", "startDate", "yearRange", "1900:2100", "appendTo", "body", "styleClass", "p-form-datepicker", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "placeholder", "MM/DD/YYYY", 1, "im-input-calendar", "mw-100", 3, "disabled", "minDate", "inputStyle", "ngModel", "showIcon", "showButtonBar", "ngModelChange"]], template: function CustomCalenderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CustomCalenderComponent_div_0_Template, 8, 17, "div", 0);
        i0.ɵɵtemplate(1, CustomCalenderComponent_div_1_Template, 7, 10, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !(ctx.inputParams == null ? null : ctx.inputParams.showTodayByDefault));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.showTodayByDefault);
    } }, directives: [i6.NgIf, i1.NgControlStatusGroup, i1.FormGroupDirective, i6.NgClass, i7.Calendar, i1.NgControlStatus, i1.FormControlName, i1.NgModel], styles: [".p-calendar[_ngcontent-%COMP%]   .p-datepicker-trigger[_ngcontent-%COMP%]{color:#fff!important}.leftAlign[_ngcontent-%COMP%]   .vd-heading-container[_ngcontent-%COMP%]{float:left!important}.leftAlign[_ngcontent-%COMP%]   .inlineblock[_ngcontent-%COMP%]{width:100%!important;float:left!important}.error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomCalenderComponent, [{
        type: Component,
        args: [{
                selector: 'custom-calender',
                templateUrl: 'custom-calender.component.html',
                styleUrls: ['custom-calender.component.scss'
                ]
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.ActivatedRoute }, { type: i3.CustomDropdownService }, { type: i4.Store }, { type: i5.AppServicesLibraryService }]; }, { formControlName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class CustomCalenderModule {
}
CustomCalenderModule.ɵfac = function CustomCalenderModule_Factory(t) { return new (t || CustomCalenderModule)(); };
CustomCalenderModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomCalenderModule });
CustomCalenderModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomCalenderModule, { declarations: [CustomCalenderComponent], imports: [ReactiveFormsModule,
        PrimengLibraryModule], exports: [CustomCalenderComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomCalenderModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomCalenderComponent],
                imports: [
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [CustomCalenderComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-calender
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomCalenderComponent, CustomCalenderModule, CustomCalenderService };
//# sourceMappingURL=custom-calender.js.map
